import { backendApi } from "@/services/api";
import { Filter } from "@/shared/lib/filter/filter";
import { Counting } from "./countings";

const countingsApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    createCounting: build.mutation<Response, CreateRequest>({
      query: (request) => ({
        url: `/inspections/countings`,
        method: "POST",
        body: request,
      }),
      invalidatesTags: ["Countings", "Documentations"],
    }),
    putCounting: build.mutation<Response, PutRequest>({
      query: (request) => ({
        url: `/inspections/countings`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Countings"],
    }),
    showCounting: build.query<Response, ShowRequest>({
      query: (request) => ({
        url: `/inspections/countings/${request.id}`,
        method: "GET",
      }),
      providesTags: (_result, _e, request) => [
        { type: "Countings", id: request.id },
      ],
    }),
    listCountings: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/inspections/countings`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["Countings"],
    }),
  }),
});

export const {
  useCreateCountingMutation,
  useShowCountingQuery,
  usePutCountingMutation,
  useListCountingsQuery,
} = countingsApi;

export interface Response {
  counting: Counting;
}

export interface CreateRequest {
  id: string;
  processId: string;
  customerId: string;
  documentationId: string;
  createdBy: string;
}

export interface PutRequest {
  counting: Counting;
}

export interface ShowRequest {
  id: string;
}

export interface ShowForProcessRequest {
  processId: string;
}

export interface ListRequest {
  processId?: Filter<string>;
  ownerId?: Filter<string>;
  ownerType?: Filter<string>;
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: Counting[];
}
